import { Logger } from "aws-amplify";
import AppSettings from "@/appsettings/appsettings.js";

const LOG_LEVELS = {
  verbose: "VERBOSE",
  debug: "DEBUG",
  info: "INFO",
  warn: "WARN",
  error: "ERROR",
  none: "NONE"
};

function getLogLevel() {
  try {
    const logLevel = LOG_LEVELS[AppSettings.logLevel];
    if (logLevel == null || logLevel == undefined)
      throw new Error("Improper log level config");
    return logLevel;
  } catch (e) {}
  return LOG_LEVELS.none;
}

const LOG_LEVEL = getLogLevel();

const logger = new Logger("LoggerService", LOG_LEVEL);

export function verbose(msg) {
  logger.verbose(msg);
}

export function debug(msg) {
  logger.debug(msg);
}

export function info(msg) {
  logger.info(msg);
}

export function warn(msg) {
  logger.warn(msg);
}

export function error(msg) {
  logger.error(msg);
}
